/**
 * @generated SignedSource<<1f727d9f71bd6db3f243f15c0b878f5a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserSync_viewer$data = {
  readonly me: {
    readonly email: string;
    readonly id: string;
    readonly isSuperAdmin: boolean;
  } | null | undefined;
  readonly " $fragmentType": "UserSync_viewer";
};
export type UserSync_viewer$key = {
  readonly " $data"?: UserSync_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserSync_viewer">;
};

import UserSyncQueryRefetch_graphql from './UserSyncQueryRefetch.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": UserSyncQueryRefetch_graphql
    }
  },
  "name": "UserSync_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSuperAdmin",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b13e84eb7898fc46b3a8968fc9fe0654";

export default node;
